	<div fxLayout="column" fxLayoutAlign='space-between'  fxLayoutGap="30px">
		<div fxFlex="25%">
			<app-dashboard-app></app-dashboard-app>
		</div>
		<div fxFlex="grow"  fxLayout="row" fxLayoutGap="30px" >
			<div fxFlex>
					<app-dashboard-record></app-dashboard-record>
			</div>
			<div fxFlex>
					<app-dashboard-company></app-dashboard-company>
			</div>
		</div>
	</div>